var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoreImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.8097,
    height: 37.8128,
    rx: 5.56026,
    fill: "#4790F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1719 23.4141L15.6159 20.97L12.7549 18.109L10.3108 20.553L13.1719 23.4141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1719 23.4141L15.6159 20.97L12.7549 18.109L10.3108 20.553L13.1719 23.4141Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1719 23.4141L15.6159 20.97L12.7549 18.109L10.3108 20.553L13.1719 23.4141Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.45638,
    height: 8.98658,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 19.8438 23.7266)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.45638,
    height: 8.98658,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 19.8438 23.7266)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.45638,
    height: 8.98658,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 19.8438 23.7266)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.45638,
    height: 13.1342,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 25.9609 23.4844)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.45638,
    height: 13.1342,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 25.9609 23.4844)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.45638,
    height: 13.1342,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 25.9609 23.4844)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreImage);
export default __webpack_public_path__ + "static/media/StoreImage.de79769f0a55500987cddcaf2b557169.svg";
export { ForwardRef as ReactComponent };